<mat-icon
  class="info-icon"
  [matTooltip]="text"
  [matTooltipPosition]="'before'"
  #tooltip="matTooltip"
  matTooltipClass="my-tooltip"
  (click)="tooltip.toggle()"
  >info_outlined</mat-icon
>
